<template>
  <q-row>
<!--    <q-toolbar-->
<!--      class="bpmn-toolbar"-->
<!--      :buttons="buttons"-->
<!--      @buttonClick="toolbarClick"-->
<!--    />-->

<!--    <q-panel>-->
<!--      <q-json>{{ this.elements }}</q-json>-->
<!--    </q-panel>-->

    <q-panel>
      <div class="containers with-diagram">
        <div
          ref="canvas"
          class="canvas"
          :style="getStyle()"
        />
      </div>
    </q-panel>

    <q-dialog
      title="--"
      :close-on-click-modal="false"
      :visible.sync="dialog"
    >
      <element-detail
        v-model="currentActivity"
        :fromStructure="currentActivityFromStructure"
        :element="element"
      />

      <span
        slot="footer"
        class="dialog-footer"
      >
        <q-button @click="dialog = false">ببند</q-button>
      </span>
    </q-dialog>
  </q-row>
</template>

<script>
  import customModeler from  '../../../q-components/q-bpmn/custom-modeler'
  import customTranslate from '../../../q-components/q-bpmn/custom-modeler/customTranslate/customTranslate';
  import elementDetail from '../../../q-components/q-bpmn/elementsDetail/elementDetail'
  import caller from '../../../q-components/q-caller';

  export default {
    name: 'QBPMNDesigner',

    components: {
      'element-detail': elementDetail
    },
    props: {
      processId: {type: String, required: true}
    },

    data() {
      return {
        currentElement: {},
        buttons: [
          {
            key: '1',
            buttons: [
              {
                key: 'persist',
                type: null,
                icon: 'check',
                caption: null,
                plain: true
              },
              {
                key: 'eject',
                type: null,
                icon: 'eject',
                caption: null,
                plain: true
              }
            ]
          },
          {
            key: '2',
            buttons: [
              {
                key: 'messageList',
                type: null,
                icon: undefined,
                caption: 'Messages',
                plain: true
              },
              {
                key: 'signalList',
                type: null,
                icon: undefined,
                caption: 'Signals',
                plain: true
              },
              {
                key: 'escalationList',
                type: null,
                icon: undefined,
                caption: 'Escalations',
                plain: true
              },
              {
                key: 'exceptionList',
                type: null,
                icon: undefined,
                caption: 'Exceptions',
                plain: true
              }
            ]
          }
        ],

        elements: [],
        elementTypes: [
          {
            key: ''
          }
        ],


        model: undefined,

        bpmnModeler: null,
        canvas: null,
        dialog: false,

        currentActivityFromStructure: undefined,
        currentActivity: undefined,
        element: null,
      };
    },
    computed: {},
    methods: {
      initialize(data) {

        this.model = data.model;

        if (!this.model.xml) {
          this.model.xml = defaultXml;
        }

        this.$eventHub.$emit("onPageChanging", {
          caption: 'caption',
          note: 'note'
        });

        const canvas = this.$refs.canvas;

        let customTranslateModule = {
          translate: ['value', customTranslate]
        };

        this.bpmnModeler = new customModeler({
          container: canvas,
          additionalModules: [
            customTranslateModule
          ]
        });
        window.bpmnjs = this.bpmnModeler;

        let eventBus = this.bpmnModeler.get('eventBus');

        // console.log(eventBus);

        this.bpmnModeler.importXML(this.model.xml, (error) => {
          if (!error) {
            this.bpmnModeler.get('canvas').zoom('fit-viewport');
          }
        });

        document.addEventListener("element.setting", (e) => {
          this.showElementDetail(e.detail.element);
        });

        eventBus.on('element.changed', (e) => {
          let ac = this.getActivity(e.element.businessObject);
          console.log('Activity: ', ac);
        });

        eventBus.on('shape.remove', (e) => {
          console.log('removing: ', e.element.businessObject.id);
          let models = this.$tools.cloneList(this.elements);
          console.log('models', models);

          const index = models.findIndex(d => d.key === e.element.businessObject.id);
          console.log(index);
          if (index > -1) models.splice(index, 1);

          setTimeout(() => {
            this.elements = models;
          }, 2);
        });

        eventBus.on('connection.remove', (e) => {
          console.log('removing: ', e.element.businessObject.id);
          let models = this.$tools.cloneList(this.elements);
          console.log('models', models);

          const index = models.findIndex(d => d.key === e.element.businessObject.id);
          console.log(index);
          if (index > -1) models.splice(index, 1);

          setTimeout(() => {
            this.elements = models;
          }, 2);
        });
      },

      removeElement(elementKey){
        console.log('removing: ', elementKey);
        let models = this.$tools.cloneList(this.elements);
        console.log('models', models);

        const index = models.findIndex(d => d.key === elementKey);
        console.log(index);
        if (index > -1) models.splice(index, 1);

        setTimeout(() => {
          this.elements = models;
        }, 200);
      },


      showElementDetail(element) {

        let elementRegistry = this.bpmnModeler.get('elementRegistry');
        this.element = elementRegistry.get(element.id).businessObject;


        this.currentActivity = this.getActivity(this.element);

        this.$delegate('structure', 'fetchFormStructure', {
          structureKey: this.currentActivity.type
        }).then((response) => {
          this.currentActivityFromStructure = response.result;
          this.dialog = true;
        }).catch(() => {
        });
      },
      getFormStructureKey(element) {
        let xx = element.$type.replace("bpmn:", "");
        let key = xx.charAt(0).toLowerCase() + xx.slice(1);

        let eventDefinition = undefined;

        if (element.eventDefinitions && element.eventDefinitions.length > 0) {
          let x = element.eventDefinitions[0].$type.replace("bpmn:", "");
          eventDefinition = x.charAt(0).toLowerCase() + x.slice(1);
        }
        if (key === 'startEvent') {
          if (eventDefinition) {
            if (eventDefinition === "messageEventDefinition")
              key = 'messageStartEvent';
            else if (eventDefinition === "timerEventDefinition")
              key = 'timerStartEvent';
            else if (eventDefinition === "conditionalEventDefinition")
              key = 'conditionalStartEvent';
            else if (eventDefinition === "signalEventDefinition")
              key = 'signalEndEvent';
            else
              key = 'startEvent';
          }
        } else if (key === 'boundaryEvent') {
          if (eventDefinition) {
            if (eventDefinition === "messageEventDefinition")
              key = 'messageBoundaryEvent';
            else if (eventDefinition === "timerEventDefinition")
              key = 'timerBoundaryEvent';
            else if (eventDefinition === "escalationEventDefinition")
              key = 'escalationBoundaryEvent';
            else if (eventDefinition === "conditionalEventDefinition")
              key = 'conditionalBoundaryEvent';
            else if (eventDefinition === "errorEventDefinition")
              key = 'exceptionBoundaryEvent';
            else if (eventDefinition === "signalEventDefinition")
              key = 'signalBoundaryEvent';
            else if (eventDefinition === "compensateEventDefinition")
              key = 'compensationBoundaryEvent';
            else
              key = 'boundaryEvent';
          }
        } else if (key === 'endEvent') {
          if (eventDefinition) {
            if (eventDefinition === "messageEventDefinition")
              key = 'messageEndEvent';
            else if (eventDefinition === "escalationEventDefinition")
              key = 'escalationEndEvent';
            else if (eventDefinition === "errorEventDefinition")
              key = 'exceptionEndEvent';
            else if (eventDefinition === "compensateEventDefinition")
              key = 'compensationEndEvent';
            else if (eventDefinition === "signalEventDefinition")
              key = 'signalEndEvent';
            else if (eventDefinition === "terminateEventDefinition")
              key = 'terminateEndEvent';
            else
              key = 'endEvent';
          }
        } else if (key === 'intermediateCatchEvent') {
          if (eventDefinition) {
            if (eventDefinition === "conditionalEventDefinition")
              key = 'conditionIntermediateCatchEvent';
            else if (eventDefinition === "linkEventDefinition")
              key = 'linkIntermediateCatchEvent';
            else if (eventDefinition === "signalEventDefinition")
              key = 'signalIntermediateCatchEvent';
            else if (eventDefinition === "timerEventDefinition")
              key = 'timerIntermediateCatchEvent';
            else if (eventDefinition === "messageEventDefinition")
              key = 'messageIntermediateCatchEvent';
            else
              key = 'intermediateCatchEvent';
          }
        } else if (key === 'intermediateThrowEvent') {
          if (eventDefinition) {
            if (eventDefinition === "messageEventDefinition")
              key = 'messageIntermediateThrowEvent';
            else if (eventDefinition === "escalationEventDefinition")
              key = 'escalationIntermediateThrowEvent';
            else if (eventDefinition === "linkEventDefinition")
              key = 'linkIntermediateThrowEvent';
            else if (eventDefinition === "compensateEventDefinition")
              key = 'compensationIntermediateThrowEvent';
            else if (eventDefinition === "signalEventDefinition")
              key = 'signalIntermediateThrowEvent';
            else
              key = 'intermediateThrowEvent';
          }
        }
        return key;
      },


      getActivity(element) {

        if (!this.elements)
          this.elements = [];

        let existItem = this.elements.find((item) => {
          return item.key === element.id;
        });

        if (!existItem) {
          let newActivity = {
            type: element.$type,
            key: element.id
          };
          this.elements.push(newActivity);
          existItem = newActivity;
        }

        this.currentElement = element;
        existItem.type = this.getFormStructureKey(element);
        if (existItem.type === 'sequenceFlow') {
          if (element.sourceRef)
            existItem.source = element.sourceRef.id;
          if (element.targetRef)
            existItem.target = element.targetRef.id;
        }

        return existItem;
      },

      persistDiagram() {
        this.bpmnModeler.saveXML({format: true}, (err, xml) => {
          if (!err) {
            this.model.xml = xml;

            // delegate('bpmn', 'persistProcess', {
            //   model: this.model,
            //   elements: this.elements
            // }).then((response) => {
            //   this.$notify({
            //     title: this.$qt('model.successPersistTitle'),
            //     message:  response.result.message,
            //     type: 'success'
            //   });
            // }).catch(() => {
            // });
          }
        });
      },


      toolbarClick(key) {
        if (key === 'persist') {
          this.persistDiagram();
        }
      },


      getStyle() {
        const ret = {};

        let height = window.innerHeight;
        height -= 160;

        ret.padding = '20px';
        ret.height = height + 'px';
        ret.overflow = 'auto';

        return ret;
      },

    },
    beforeRouteEnter(to, from, next) {
      caller.delegate('bpms', 'fetchEditableProcess', {
        processId: to.params.processId === "NEW" ? null : to.params.processId
      }).then((response) => {
        next(vm => vm.initialize({
          model: response.result.model,
        }));
      }).catch(() => {
      });
    }
  }

  let defaultXml = '<?xml version="1.0" encoding="UTF-8"?>\n' +
    '<bpmn:definitions xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:bpmn="http://www.omg.org/spec/BPMN/20100524/MODEL" xmlns:bpmndi="http://www.omg.org/spec/BPMN/20100524/DI" xmlns:dc="http://www.omg.org/spec/DD/20100524/DC" id="Definitions_0n6bu57" targetNamespace="http://bpmn.io/schema/bpmn" exporter="bpmn-js (https://demo.bpmn.io)" exporterVersion="7.0.0">\n' +
    '  <bpmn:process id="Process_15tfuiv" isExecutable="false">\n' +
    '    <bpmn:startEvent id="StartEvent_1imx09t" />\n' +
    '  </bpmn:process>\n' +
    '  <bpmndi:BPMNDiagram id="BPMNDiagram_1">\n' +
    '    <bpmndi:BPMNPlane id="BPMNPlane_1" bpmnElement="Process_15tfuiv">\n' +
    '    </bpmndi:BPMNPlane>\n' +
    '  </bpmndi:BPMNDiagram>\n' +
    '</bpmn:definitions>';
    
</script>


<style lang="scss">
  @import '../../../q-components/q-bpmn/diagram-js.css';
  @import '../../../q-components/q-bpmn/diagram-js.css';
  @import '../../../q-components/q-bpmn/css/bpmn.css';
  @import '../../../q-components/q-bpmn/css/bpmn-codes.css';
  @import '../../../q-components/q-bpmn/css/bpmn-embedded.css';
  // @import 'bpmn-js-properties-panel/dist/assets/bpmn-js-properties-panel.css';*/

  .containers {
    background-color: #ffffff;
    width: 100%;
    height: 100%;
  }

  .bjs-powered-by {
    display: none;
  }

  .djs-overlay-container {
    position: inherit !important;
    width: inherit !important;
    color: black !important;
  }

  .bpmn-toolbar {
    padding-top: 15px;
    padding-left: 15px;
    padding-right: 15px;
  }
</style>
